/**
 * `@visx/vendor/d3-time-format` (CommonJS)
 * See upstream license: https://github.com/d3/d3-time-format/blob/main/LICENSE
 *
 * This file only exists for tooling that doesn't work yet with package.json:exports
 * by proxying through the CommonJS version.
 */
module.exports = require('./vendor-cjs/d3-time-format/src/index.js');